import { render, staticRenderFns } from "./ForceChangePassword.vue?vue&type=template&id=0b1f3a64&scoped=true"
import script from "./ForceChangePassword.vue?vue&type=script&lang=js"
export * from "./ForceChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ForceChangePassword.vue?vue&type=style&index=0&id=0b1f3a64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f3a64",
  null
  
)

export default component.exports